/**
 * 受注・発注 処分終了報告
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/disposal_reports`

const order_disposal_report = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 処分終了報告個別登録ダイアログ初期情報
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    show ({ commit }, { params }) {
      const api_path = `${API_PATH}/report_items`
      return new Promise((resolve) => {
        Vue.$http.post(api_path, params).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 処分終了報告一括登録ダイアログ初期情報
     * @return {Promise<unknown>}
     */
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 処分終了報告一括登録
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 処分終了報告個別登録
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}

export default order_disposal_report
